/* Små hjelparar tilbodet treng: datoformat, dokumenttittel, tastaturnavigasjon, inntoning ved scroll. */
import { useEffect, useRef } from "react";

export const MONTHS = ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"];
export const MONTHS_EN = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export const cap = (t) => t.charAt(0).toUpperCase() + t.slice(1);
export const fmtDate = (d, lang) => (lang === "en" ? `${d.getDate()} ${MONTHS_EN[d.getMonth()]} ${d.getFullYear()}` : `${d.getDate()}. ${MONTHS[d.getMonth()]} ${d.getFullYear()}`);
export const monthLabel = (d, date) => (d.lang === "en" ? MONTHS_EN[date.getMonth()] : cap(MONTHS[date.getMonth()]));

export const useMeta = (title) => {
  useEffect(() => {
    const prev = document.title;
    document.title = title;
    return () => {
      document.title = prev;
    };
  }, [title]);
};

const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
const currentIndex = (ids) => {
  const mid = window.innerHeight * 0.4;
  let cur = 0;
  ids.forEach((id, i) => {
    const el = document.getElementById(id);
    if (el && el.getBoundingClientRect().top <= mid) cur = i;
  });
  return cur;
};

export const useKeys = (ids) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.metaKey || e.ctrlKey || e.altKey || /input|textarea/i.test(e.target.tagName)) return;
      const i = currentIndex(ids);
      if (["ArrowDown", "j", "PageDown"].includes(e.key) && i < ids.length - 1) {
        e.preventDefault();
        go(ids[i + 1]);
      }
      if (["ArrowUp", "k", "PageUp"].includes(e.key) && i > 0) {
        e.preventDefault();
        go(ids[i - 1]);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [ids]);
};

const reduced = () => typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const useReveal = () => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (reduced()) {
      el.classList.add("in");
      return;
    }
    /* several entries can arrive in one batch (layout shifts above move the section) – any intersecting one counts */
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          el.classList.add("in");
          io.disconnect();
        }
      },
      { rootMargin: "0px 0px -8% 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return ref;
};
